<script lang="ts">
    import { closeAllModals, isCrossModalOpened, currentTabMainMenu } from '../../store/ui';
    import ButtonWrapper from '../../components/ui/buttons/button-wrapper.svelte';
    import IconSettings from '../../components/icons/icon-settings.svelte';
    import { MODAL_TABS } from '../../constants';
    import sectorOneImg from '@src/assets/img/bets/1_2x.webp';
    import sectorTwoImg from '@src/assets/img/bets/2_2x.webp';
    import sectorFiveImg from '@src/assets/img/bets/5_2x.webp';
    import sectorTenImg from '@src/assets/img/bets/10_2x.webp';
    import sectorBallSpinImg from '@src/assets/img/bets/bs_2x.webp';
    import sectorPlinkoImg from '@src/assets/img/bets/pl_2x.webp';
    import sectorCashReelsImg from '@src/assets/img/bets/cr_2x.webp';
    import sectorFortuneWheelImg from '@src/assets/img/bets/fw_2x.webp';
    import Chip from './chips/chip.svelte';
    import { selectedChipIndex, chipBetPerColor } from '@root/src/store/chips';

    import { allowToBet, gameState, gameStatus } from '@root/src/store';
    import { gameStates } from '@root/src/states/machine/state-types';

    // let reverseDprTransform = `scale(1)`;
    // window.addEventListener('resize', updateDPR);
    // updateDPR();
    // const translate = 'translate(0, 0)';
    // function updateDPR() {
    //     reverseDprTransform = `${translate} scale(${1 / window.devicePixelRatio})`;
    // }
    const bets = [
        { imgSrc: sectorOneImg },
        { imgSrc: sectorTwoImg },
        { imgSrc: sectorFiveImg },
        { imgSrc: sectorTenImg },
        { imgSrc: sectorBallSpinImg },
        { imgSrc: sectorPlinkoImg },
        { imgSrc: sectorCashReelsImg },
        { imgSrc: sectorFortuneWheelImg }
    ];
</script>

<!-- style="transform: {reverseDprTransform};" -->
<div class="top-container absolute mt-2.5">
    <div class=" relative z-[9010]">
        <div class="absolute right-2 top-1 h-10 w-10">
            <ButtonWrapper
                class="h-full w-full rounded-full desktop:hidden"
                on:click={() => {
                    closeAllModals();
                    $isCrossModalOpened = true;
                    $currentTabMainMenu = MODAL_TABS.SETTINGS;
                }}
            >
                <IconSettings />
            </ButtonWrapper>
        </div>
        <div class="absolute right-2 top-1">
            {#if !$allowToBet && $gameState === gameStates.game}
                <div class="bets-container">
                    {#each bets as bet, index}
                        {#if $chipBetPerColor[index] > 0}
                            <div class="bets-item">
                                <img src={bet.imgSrc} alt="sector bet" />
                                <div>
                                    <Chip
                                        class="parent-chip h-7 w-7 text-md desktop:h-8 desktop:w-8"
                                        value={$chipBetPerColor[index]}
                                        index={$selectedChipIndex}
                                    />
                                </div>
                            </div>
                        {/if}
                    {/each}
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    .bets-container {
        position: absolute;
        right: -7px;
        top: 40px;
        display: flex;
        flex-direction: column;
        width: 69px;
    }

    .bets-item {
        position: relative;
        margin-bottom: -20px;
        width: 69px;
    }

    .bets-item img {
        position: relative;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .bets-item div {
        position: absolute;
        top: 13px;
        left: -7px;
    }

    .top-container {
        top: var(--ui-screen-top);
        width: 100%;
    }
</style>
